import React from 'react';

const initialState = {
  sessionId: undefined,
  roomId: undefined,
};

export const SessionContext = React.createContext(initialState);
